import React from 'react';
import logo from '../../assets/dio_art_logo_black.svg';
import GaleryCollections from './components/GaleryCollections';
import './styles.css';

const ContainerCollections = ({ categoriesObj, eventData }) => {
  return (
    <div
      style={{
        minHeight: eventData.height * 0.7,
        minWidth: eventData.width,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          paddingTop: 16,
          paddingBottom: 16,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <img src={logo} className="App-logo" alt="logo" />
        <div
          className="welcomeMessage"
          style={{ paddingTop: 16 }}
        >{`¡Hola! Acá te comparto un recorrido visual de mi trabajo, una selección de obras -pinturas y dibujos- que nacieron de ideas, emociones y momentos. Te invito a explorar la galería y si alguna obra resuena con vos, podes adquirirla desde la tienda. Gracias por estar acá, espero disfrutes la visita.`}</div>
      </div>
      <GaleryCollections categoriesObj={categoriesObj} />
    </div>
  );
};

export default ContainerCollections;
